export interface UserDisplayIdentity {
  nickname?: unknown;
  name_en?: unknown;
  full_name_en?: unknown;
  fullNameEn?: unknown;
  username?: unknown;
}

/** User labels across API field aliases; blank values fall through. */
export function getUserDisplayName(
  user: UserDisplayIdentity | null | undefined,
  fallback: unknown = "",
): string {
  for (const value of [
    user?.nickname,
    user?.name_en,
    user?.full_name_en,
    user?.fullNameEn,
    user?.username,
  ]) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return fallback == null ? "" : String(fallback);
}

/** SQL users entities use full_name_en for the English name. */
export function userDisplayNameSql(alias: string, fallback = "'-'"): string {
  if (alias && !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(alias))
    throw new Error("Invalid user alias");
  const prefix = alias ? `${alias}.` : "";
  return `COALESCE(NULLIF(TRIM(${prefix}nickname), ''), NULLIF(TRIM(${prefix}full_name_en), ''), NULLIF(TRIM(${prefix}username), ''), ${fallback})`;
}
